import { useRef, useState } from "react";

import { Observation } from "@medplum/fhirtypes";

import { useLaborFlowsheetEditRouteContext } from "@/encounters/components/EncounterLabor/EncounterLaborTable/LaborRow/Common/use-labor-flowsheet-edit-route-context";
import { FetalHeartRateFlowsheetDrawer } from "@/encounters/components/EncounterLabor/flowsheet-forms/fetal-heart-rate";

interface EditFetalHeartRateLaborRowProps {
  observation: Observation;
  questionnaireDisplayName: string;
  onClose?: () => void;
}

export default function EditFetalHeartRateLaborRow({
  observation,
  questionnaireDisplayName,
  onClose,
}: EditFetalHeartRateLaborRowProps) {
  const [opened, setOpened] = useState(true);
  const { encounterId, clientId, hasRouteContext } = useLaborFlowsheetEditRouteContext(onClose);

  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  const handleClose = () => {
    setOpened(false);
    onCloseRef.current?.();
  };

  if (!hasRouteContext || !encounterId || !clientId) {
    return null;
  }

  return (
    <FetalHeartRateFlowsheetDrawer
      mode="edit"
      opened={opened}
      clientId={clientId}
      onClose={handleClose}
      encounterId={encounterId}
      observation={observation}
      title={questionnaireDisplayName}
      questionnaireDisplayName={questionnaireDisplayName}
    />
  );
}
